/**
 * Partner Quotes Demo Page
 *
 * Standalone page to test the Partner Quote Widget
 * Navigate to /partner-quotes-demo to see it in action
 */

import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import PartnerQuoteSection from '../components/PartnerQuotes/PartnerQuoteSection';

const PartnerQuotesDemo = () => {
  const handleQuotesSaved = (quotes, selectedQuote) => {
    console.log('✅ Quotes saved successfully!');
    console.log('All quotes:', quotes);
    console.log('Selected quote:', selectedQuote);
    alert(`Quote saved! Partner: ${selectedQuote.partnerName}, Cost: $${selectedQuote.quote.totalCost.toFixed(2)}/unit`);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4, bgcolor: 'background.paper' }}>
        <Typography variant="h3" gutterBottom color="text.primary">
          Partner Quote Widget Demo
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          This is a working demo of the Partner Quote integration. Click "Get Partner Quotes"
          to fetch LIVE quotes from production partners.
        </Typography>
        <Typography variant="body2" color="success.main" paragraph>
          ✅ LIVE MODE: Currently using <strong>real API calls</strong> to Scalable Press and Apliiq.
          Quotes are fetched in real-time from production partner APIs.
        </Typography>
      </Paper>

      <PartnerQuoteSection
        brandId="demo-brand-123"
        lookId="demo-look-456"
        garmentSKU="GILDAN-5000"
        quantity={50}
        decorationSpecs={{
          method: 'dtg',
          placements: [{
            location: 'front_chest',
            width: 12,
            height: 12
          }]
        }}
        garmentDetails={{
          type: 'tshirt',
          color: 'white',
          sizes: ['S', 'M', 'L', 'XL']
        }}
        existingQuotes={[]}
        selectedQuote={null}
        onQuotesSaved={handleQuotesSaved}
      />

      <Box mt={4}>
        <Paper sx={{ p: 3, bgcolor: 'grey.100' }}>
          <Typography variant="h6" gutterBottom color="text.primary">
            Test Instructions
          </Typography>
          <Typography variant="body2" component="div" color="text.primary">
            <ol>
              <li>Click the "Get Partner Quotes" button above</li>
              <li>Wait for LIVE quotes to load from partner APIs</li>
              <li>Review real-time quotes from production partners (Scalable Press and/or Apliiq)</li>
              <li>Click "More Details" to see full cost breakdown</li>
              <li>The recommended partner is auto-selected based on cost and lead time</li>
              <li>Click "Save Quote" to save to database</li>
              <li>Check browser console for saved data</li>
            </ol>
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default PartnerQuotesDemo;
